import { createSelector } from 'reselect';

const selectTagNames = (state: any) => state.tagNames;


export const selectTagNamesCurrentItem = createSelector([selectTagNames], (tagNames) => tagNames.current);

export const selectTagNamesListItems = createSelector([selectTagNames], (tagNames) => tagNames.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectTagNamesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectTagNamesQueryItems = createSelector([selectTagNames], (tagNames) => tagNames.query);

export const selectTagNamesCreatedItem = createSelector([selectTagNames], (tagNames) => tagNames.create);

export const selectTagNamesUpdatedItem = createSelector([selectTagNames], (tagNames) => tagNames.update);

export const selectTagNamesReadItem = createSelector([selectTagNames], (tagNames) => tagNames.read);

export const selectTagNamesDeletedItem = createSelector([selectTagNames], (tagNames) => tagNames.delete);

export const selectTagNamesSearchedItems = createSelector([selectTagNames], (tagNames) => tagNames.search);

export const selectTagNamesItemsCount = createSelector([selectTagNames], (tagNames) => tagNames.count);

export const selectTagNamesItemsFilter = createSelector([selectTagNames], (tagNames) => tagNames.filter);